import React from 'react';
import moment from 'moment';

/**
 * Groups messages by day and formats date labels
 * @param {Array} messages - Array of message objects with timestamp
 * @returns {Array} Array of { dateDisplay, messages } objects
 */
export const groupMessagesByDay = (messages = []) => {
  // Group messages by day
  const grouped = messages.reduce((acc, message) => {
    const timestamp = message.timestamp || message.created_at;
    if (!timestamp) return acc;
    
    const day = moment(timestamp).startOf('day').format('YYYY-MM-DD');
    if (!acc[day]) acc[day] = [];
    acc[day].push(message);
    return acc;
  }, {});

  // Sort days and format messages within each day
  return Object.entries(grouped)
    .sort(([dayA], [dayB]) => moment(dayA).valueOf() - moment(dayB).valueOf())
    .map(([day, dayMessages]) => {
      const date = moment(day);
      const isToday = date.isSame(moment(), 'day');
      const isYesterday = date.isSame(moment().subtract(1, 'day'), 'day');

      const dateDisplay = isToday 
        ? 'Today' 
        : isYesterday 
        ? 'Yesterday' 
        : date.format('MMMM D, YYYY');

      // Sort messages by time within the day
      const sortedMessages = dayMessages.sort((a, b) => {
        const timeA = moment(a.timestamp || a.created_at);
        const timeB = moment(b.timestamp || b.created_at);
        return timeA.valueOf() - timeB.valueOf();
      });

      return {
        dateDisplay,
        messages: sortedMessages
      };
    });
};

/**
 * Component to display a date separator
 */
export const MessageDateSeparator = ({ dateDisplay }) => (
  <div className="flex justify-center mb-4">
    <div className="px-3 py-1 text-xs text-gray-500 bg-gray-100 rounded-full">
      {dateDisplay}
    </div>
  </div>
);

